import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-befb69b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-bar row align-items-center justify-content-center d-flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iconbutton = _resolveComponent("iconbutton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.request.routeState.targetRoutes?.backTargetRoute !== undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "col",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
        }, [
          _createVNode(_component_iconbutton, { disabled: _ctx.disabledRoutedButton }, {
            icontext: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.getBackText()), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.getBackImageUrl(),
                alt: "Hidden",
                class: "button-container"
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_3,
    _hoisted_4,
    (_ctx.request.routeState.targetRoutes?.vorwardTargetRoute !== undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "col",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next()))
        }, [
          _createVNode(_component_iconbutton, { disabled: _ctx.disabledRoutedButton }, {
            icontext: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.getForwardText()), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.getForwardImageUrl(),
                alt: "Hidden",
                class: "button-container"
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}